import EditableField from '../EditableField';
import ImagePreview from '../../ImagePreview';
import { Card } from '../../ui/card';
import { Label } from '../../ui/label';
import { BankAttachmentUpload } from '../BankAttachmentUpload';

const KycTab = ({ editData, updateField, canEdit, editingField, editingValue, setEditingValue, startEditing, confirmEdit, cancelEdit }) => {
  const editProps = { canEdit, editingField, editingValue, setEditingValue, startEditing, confirmEdit, cancelEdit };

  return (
    <div className="space-y-4">
      <div className="grid grid-cols-2 gap-4">
        <Card className="p-2 divide-y">
          <div className="px-3 py-2"><h3 className="font-semibold text-sm text-slate-700">Aadhaar</h3></div>
          <EditableField field="aadhaarNo" label="Aadhaar Number" value={editData.aadhaarNo} {...editProps} />
          <div className="px-3 py-2">
            <Label className="text-xs text-slate-500">Aadhaar Document</Label>
            <div className="mt-1"><ImagePreview imageUrl={editData.aadhaarDataUrl} label="Aadhaar" /></div>
            <BankAttachmentUpload field="aadhaar" className="mt-2" accept="image/*,.pdf" data-testid="kyc-aadhaar-upload" />
          </div>
        </Card>
        <Card className="p-2 divide-y">
          <div className="px-3 py-2"><h3 className="font-semibold text-sm text-slate-700">PAN Card</h3></div>
          <EditableField field="panNo" label="PAN Number" value={editData.panNo} {...editProps} />
          <div className="px-3 py-2">
            <Label className="text-xs text-slate-500">PAN Document</Label>
            <div className="mt-1"><ImagePreview imageUrl={editData.panDataUrl} label="PAN Card" /></div>
            <BankAttachmentUpload field="pan" className="mt-2" accept="image/*,.pdf" data-testid="kyc-pan-upload" />
          </div>
        </Card>
      </div>
      <Card className="p-2 divide-y"><EditableField field="kycNotes" label="KYC Notes" value={editData.kycNotes} {...editProps} /></Card>
    </div>
  );
};

export default KycTab;
